import { webCoreTypes } from "@core/core-types.di";
import { FallbackError } from "@core/domain/errors/fallback.error";
import type { Nullable } from "@core/domain/types/nullable.type";
import type { IotApiClient } from "@iot-platform/core";
import type { NotebookDto } from "@notebook/data/dto/notebook.dto";
import { NotebookMapper } from "@notebook/data/mappers/notebook.mapper";
import type { Notebook } from "@notebook/domain/models/notebook.model";
import { inject, injectable } from "inversify";
import type { ResultAsync } from "neverthrow";

@injectable()
export class NotebookDatasource {
    static readonly NOTEBOOK_GENERAL_PATH = "/notebooks";
    static readonly NOTEBOOK_PATH = "/stations/:stationId/notebooks";

    constructor(
        @inject(webCoreTypes.infrastructure.IotApiClient)
        private readonly iotApiClient: IotApiClient,
        @inject(NotebookMapper)
        private readonly notebookMapper: NotebookMapper,
    ) {}

    fetchById(
        notebookId: string,
    ): ResultAsync<Nullable<Notebook>, FallbackError> {
        return this.iotApiClient.http
            .get<NotebookDto>(
                `${NotebookDatasource.NOTEBOOK_GENERAL_PATH}/${notebookId}`,
            )
            .mapErr(() => new FallbackError())
            .andThen((response) =>
                this.notebookMapper
                    .map(response.data)
                    .mapErr(() => new FallbackError()),
            );
    }
}
